import { api } from '../plugins/axios';
import { Paged } from '../types/common';
import { Popup, UpdatePopupDto } from '../types/popup';

export const getPopups = (
  query?: string,
  page?: number,
  itemsPerPage?: number
) => {
  const params = {
    page: page || 1,
    itemsPerPage: itemsPerPage || 30,
  };
  return api.get<Paged<Popup>>(`/admin/pop-ups?${query}`, {
    params,
  });
};

export const getPopup = () => {
  return api.get<Popup>(`/admin/pop-ups/one`);
};

export const patchPopup = (id: number, data: Partial<UpdatePopupDto>) => {
  return api.patch<Popup>(`/admin/pop-ups/${id}`, data);
};
